module.exports = __webpack_public_path__ + "img/food-item-default.52eee5dd.jpg";